if (!customElements.get('cart-progress-bar') && window.cartThreshold.enabled) {
	class CartProgressBar extends HTMLElement {
		constructor() {
			super();
			this.progressBar = this.querySelector('.progress-bar');
			this.priceThresholdValue = Math.max(
				...Object.values(window.cartThreshold.priceThresholdValue),
			);
			this.tieredProgressBars = Array.from(document.querySelectorAll('.progress-bar__tiered'));
			this.priceLevels = Object.values(window.cartThreshold.priceThresholdValue).filter((el) => el);
			this.progressStatuses = Object.values(window.cartThreshold.progressStatus).filter((el) => el);
			document.addEventListener('rebuy:cart.ready', (event) => this.cartProgressUpdate(event));
			document.addEventListener('rebuy:cart.change', (event) => this.cartProgressUpdate(event));
			window.rebuyCartEvent && this.cartProgressUpdate(window.rebuyCartEvent);
		}

		cartProgressUpdate(event) {
			if (!this.progressBar) return;
			const { total_price,  items_subtotal_price} = event.detail.cart.cart;
			const subtotalPrice = items_subtotal_price / 100;
			const percentageValue = (subtotalPrice / this.priceThresholdValue) * 100;
			const newPercentValue = percentageValue > 100 ? 100 : percentageValue;

			this.updateProgressBar(newPercentValue);
			this.updateLevelProgress(subtotalPrice);
			this.updateProgessWidths();
			this.updateProgressLevelMarks(subtotalPrice);
			window.cartThreshold.footerDiscountView && this.updateCartFooter(event.detail.cart.cart);
		}

		updateCartFooter(cart) {
			const discountEl = document.querySelector(
				'.rebuy-cart__flyout-subtotal-discount-percentage-value',
			);
			const amountSaveContainer = document.querySelector(
				'.rebuy-cart__flyout-subtotal-discount',
			);
			const discountDifference = document.querySelector(
				'.rebuy-cart__flyout-subtotal-discount-difference',
			);
			const priceWithoutDiscountEl = document.querySelector(
				'.rebuy-cart__flyout-subtotal-amount-value',
			);
			const discountArr = cart.cart_level_discount_applications;
			const percentageDiscount = discountArr?.find((el) => el.value_type === 'percentage');
			const cartTotalPrice = cart.total_price;
			priceWithoutDiscountEl.textContent = `${cartTotalPrice / 100}`;
		
			amountSaveContainer.classList.toggle("hidden", !percentageDiscount);
			
			if (!percentageDiscount) return;
			const discountPriceAmount = (percentageDiscount.total_allocated_amount / 100).toFixed(1);
			const percentageValue = parseInt(percentageDiscount?.value);
			const priceWithoutDiscountValue =
				(percentageDiscount.total_allocated_amount + cartTotalPrice) / 100;
				
			
			discountEl.textContent = percentageValue ? `${percentageValue}% OFF` : '';
			priceWithoutDiscountEl.textContent = `${priceWithoutDiscountValue.toFixed(0)}`;
			discountDifference.textContent = `-${window.cartThreshold.currencySymbol}${discountPriceAmount}`;
		}

		updateProgressBar(subtotalPrice) {
			const progressBar = document.querySelector('.progress-bar');
			progressBar.setAttribute('value', subtotalPrice);
		}

		updateProgressLevelMarks(subtotalPrice) {
			const tieredProgressBars = Array.from(
				document.querySelectorAll('.progress-bar__icon-container'),
			);

			tieredProgressBars.forEach((el, idx) => {
				idx === 0 && el.classList.toggle('active', subtotalPrice > 0);
				if (idx !== 0) {
					const priceDifference = subtotalPrice - this.priceLevels[idx - 1];
					el.classList.toggle('active', priceDifference >= 0);
				}
			});
		}

		updateProgessWidths() {
			const tieredProgressBars = Array.from(
				document.querySelectorAll('.progress-bar__icon-container'),
			);
			this.priceLevels.forEach((el, idx, arr) => {
				const lastElIdx = arr.length - 1;
				const highestPrice = arr[lastElIdx];
				if (idx === lastElIdx) return;
				const currentProgressWidth = (el * 100) / highestPrice;
				tieredProgressBars[idx + 1].style.left = `${currentProgressWidth}%`;
			});
		}

		updateLevelProgress(subtotalPrice) {
			this.priceLevels.forEach((level, idx) => {
				const priceDifference = (level - subtotalPrice).toFixed(0);
				if (idx === 0) {
					priceDifference > 0 && this.updateProgressText(priceDifference, idx);
				}
				if (subtotalPrice >= this.priceLevels[idx - 1]) {
					const prevLevelDifference = subtotalPrice > this.priceLevels[idx - 1];
					const priceLevelEquals = subtotalPrice = this.priceLevels[idx - 1]
					if (priceDifference > 0 && prevLevelDifference) {
						this.updateProgressText(priceDifference, idx);
					} else if (priceDifference <= 0 && this.priceLevels.length - 1 === idx) {
						this.updateProgressText(priceDifference, idx);
					}else if(priceDifference > 0 && priceLevelEquals){
						this.updateProgressText(priceDifference, idx);
					}
				}
			});
		}

		updateProgressText(remainingAmount, levelIndex) {
			const progressText = document.querySelector('.progress-text');
			const completedProgressText = document.querySelector('.completed-progress-text');
			const isRemainingAmount = remainingAmount > 0;
			const currentStatusText = this.progressStatuses[levelIndex];
			progressText.classList.toggle('hidden', !isRemainingAmount);
			completedProgressText.classList.toggle('hidden', isRemainingAmount);

			if (isRemainingAmount) {
				const updatedProgressText = currentStatusText.replace(
					'[[amount]]',
					`${window.cartThreshold.currencySymbol}${remainingAmount}`,
				);
				progressText.innerHTML = updatedProgressText;
			}
		}
	}

	customElements.define('cart-progress-bar', CartProgressBar);
}
